import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
// import { Col, Row } from 'reactstrap';
import { Col, Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, Row } from 'reactstrap';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { IUser } from 'src/model';
import { Svg } from '../Svg';
import { HeaderLink } from './HeaderLink';

interface ILoggedHeader {
  toggle: () => void;
  navIsOpen: boolean;
}

const getInitials = (user: IUser) => {
  return (
    (user.firstname ? user.firstname[0] : '') +
    (user.lastname ? user.lastname[0] : '')
  );
};

const LoggedHeader: React.SFC<IGlobalContextProps & RouteComponentProps & ILoggedHeader > = ( props,
  {  toggle , navIsOpen }
) => {
  const [state, setState ] = React.useState({
    navIsOpen: false,
  });

  const isActive = (pathname: string) => {
    const { location } = props;
    return location.pathname.startsWith(pathname);
  };

  const handleLogout = () => {
    const { updateUser } = props.context;
    updateUser(true);
  };

  const  tooglelooged = () =>{
    setState({ navIsOpen: !state.navIsOpen })

  };
  
  const { user } = props.context;
  const pictureUrl =
    user &&
    user.profile &&
    user.profile.picture &&
    user.profile.picture.pictureUrl;

  return (
    <Row
      className='d-flex justify-content-center align-items-center bg-white'
      tag='nav'
    > 
       <Col className='px-0'>
        <Navbar className='navbar-light' expand="md" toggleable={true}>
            
          
            
            <NavbarBrand href="/" className="mr-auto"> 
              <Link to='/dashboard/'>
                <Svg src='logo/logo-color' width={128} height={64} />
              </Link>
            </NavbarBrand>
            <NavbarToggler onClick={tooglelooged}  className={`pr-0 ${state.navIsOpen === false ? 'closed' : 'opened'}`}/>
            
        
           
            
            <Collapse  isOpen={state.navIsOpen} navbar={true}>
              <Nav className="d-flex  w-100" navbar={true}>
             
             
             
                <NavItem className='ml-auto'> 
                  <HeaderLink
                    isActive={isActive('/dashboard/') || isActive('/project/')}
                    label='Mes projets'
                    link='/dashboard/'
                    src='item'
                  />
                </NavItem>
                <NavItem  className='px-1  ml-auto ml-md-0'>
                  <HeaderLink
                    isActive={isActive('/profile/')}
                    label='Mon profil'
                    link= {user && user.type === 'consultant' ? '/profile/' : '/profile/contact/'}
                    src='user'
                  />
                </NavItem>
                <NavItem className='mr-md-auto ml-md-0 ml-auto'>
                  <HeaderLink
                    isActive={isActive('/payments/')}
                    label='Paiements'
                    link='/payments/'
                    src='euro'
                  />
                </NavItem >

              
              
                <NavItem  className='d-flex align-item-center  ml-auto ml-md-0'  >
                {user && (
                  <Link className='d-flex align-item-center' to='/'>
                    {pictureUrl ? (
                      
                      <img
                        className='d-block rounded-circle mr-4 my-auto'
                        src={pictureUrl}
                        style={{ height: '70px', width: '70px' }}
                      />
                  
                    ) : (
                      <div
                        className={`d-flex justify-content-center align-items-center rounded-circle font-weight-bold text-white bg-${
                          user && user.type === 'client' ? 'success' : 'secondary'
                        } mr-4 my-auto `}
                        style={{ fontSize: '28px', height: '70px', width: '70px' }}
                      >
                        {getInitials(user)}
                      </div>
                    )}
                  </Link>
                )}
                </NavItem>
                <NavItem  className='d-flex align-item-center ml-auto ml-md-0'>
                  <Link to='/' className='mr-4 d-flex align-item-center'>
                    <Svg
                      width={48}
                      fill={user && user.type === 'client' ? 'success' : 'secondary'}
                      src='log-out'
                      opacity={0.5}
                      onClick={handleLogout}
                    />
                  </Link>
                </NavItem>
         


                </Nav>
              </Collapse>
    

       


            </Navbar>
          
          </Col>
      {/* <Col md='2' xs='auto'>
        <Link to='/dashboard/'>
          <Svg src='logo/logo-color' width={128} height={64} />
        </Link>
      </Col>
      <Col
        md='6'
        xs='auto'
        className='d-flex justify-content-center align-items-center'
      >
        <HeaderLink
          isActive={isActive('/dashboard/') || isActive('/project/')}
          label='Mes projets'
          link='/dashboard/'
          src='item'
        />
        <HeaderLink
          isActive={isActive('/profile/')}
          label='Mon profil'
          link='/profile/contact/'
          src='user'
        />
        <HeaderLink
          isActive={isActive('/payments/')}
          label='Paiements'
          link='/payments/'
          src='euro'
        />
      </Col>
      <Col md='2' xs='auto' className='d-flex align-item-center'>
        {user && (
          <Link to='/'>
            {pictureUrl ? (
              <img
                className='d-block rounded-circle mr-4'
                src={pictureUrl}
                style={{ height: '70px', width: '70px' }}
              />
            ) : (
              <div
                className={`d-flex justify-content-center align-items-center rounded-circle font-weight-bold text-white bg-${
                  user && user.type === 'client' ? 'success' : 'secondary'
                } mr-4`}
                style={{ fontSize: '28px', height: '70px', width: '70px' }}
              >
                {getInitials(user)}
              </div>
            )}
          </Link>
        )}
        <Link to='/' className='mr-4'>
          <Svg
            width={48}
            fill={user && user.type === 'client' ? 'success' : 'secondary'}
            src='log-out'
            opacity={0.5}
            onClick={handleLogout}
          />
        </Link>
      </Col> */}
    </Row>
  );
};

export const LoggedHeaderWithGlobalContext = withGlobalContext(
  withRouter(LoggedHeader)
);



// WEBPACK FOOTER //
// ./src/components/shared/Header/LoggedHeader.tsx